function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Algemeen/Selectbox_on",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Invisible_shape",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6666667,2 L5.33333333,2 C3.48871111,2 2,3.48871111 2,5.33333333 L2,18.6666667 C2,20.5112889 3.48871111,22 5.33333333,22 L18.6666667,22 C20.5112889,22 22,20.5112889 22,18.6666667 L22,5.33333333 C22,3.48871111 20.5112889,2 18.6666667,2 Z M18.2478495,8.91652808 L10.4000396,16.8823713 C10.3258731,16.9576534 10.2254397,17 10.1203625,17 C10.0152853,17 9.91485194,16.9576534 9.83991406,16.8823713 L5.75224937,12.734833 C5.67808282,12.6595509 5.63636364,12.557607 5.63636364,12.4509494 C5.63636364,12.3442919 5.67808282,12.2423479 5.75224937,12.166283 L6.96672168,10.9335446 L6.96672168,10.9343296 C7.04088823,10.8582626 7.14132161,10.815918 7.2463988,10.815918 C7.35147599,10.815918 7.45190936,10.8582646 7.52607591,10.9343296 L10.1187407,13.5675928 L16.4739241,7.11762868 C16.5480906,7.04234665 16.648524,7 16.7536012,7 C16.8586784,7 16.9591118,7.04234665 17.0332783,7.11762868 L18.2477506,8.34801822 C18.3219172,8.42330025 18.3636364,8.52602912 18.3636364,8.63268469 C18.3636364,8.7385493 18.3219172,8.84128619 18.2477506,8.91656823 L18.2478495,8.91652808 Z",
  id: "Fill-1",
  fill: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2478495,8.91652808 L10.4000396,16.8823713 C10.3258731,16.9576534 10.2254397,17 10.1203625,17 C10.0152853,17 9.91485194,16.9576534 9.83991406,16.8823713 L5.75224937,12.734833 C5.67808282,12.6595509 5.63636364,12.557607 5.63636364,12.4509494 C5.63636364,12.3442919 5.67808282,12.2423479 5.75224937,12.166283 L6.96672168,10.9335446 L6.96672168,10.9343296 C7.04088823,10.8582626 7.14132161,10.815918 7.2463988,10.815918 C7.35147599,10.815918 7.45190936,10.8582646 7.52607591,10.9343296 L10.1187407,13.5675928 L16.4739241,7.11762868 C16.5480906,7.04234665 16.648524,7 16.7536012,7 C16.8586784,7 16.9591118,7.04234665 17.0332783,7.11762868 L18.2477506,8.34801822 C18.3219172,8.42330025 18.3636364,8.52602912 18.3636364,8.63268469 C18.3636364,8.7385493 18.3219172,8.84128619 18.2477506,8.91656823 L18.2478495,8.91652808 Z",
  id: "Path",
  fill: "#FFFFFF"
}));
function SvgSelectboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Algemeen/Selectbox_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectboxOn);
export default __webpack_public_path__ + "static/media/Selectbox_on.23312d662e206948ed71056e80fc1bee.svg";
export { ForwardRef as ReactComponent };